// Returns ROI badge label and color based on estimate
export function getRoiBadge(roi) {
  if (roi >= 1.5) return { label: "🔥 Strong ROI", color: "#38A169" };
  if (roi >= 1.2) return { label: "📈 Good ROI", color: "#3182CE" };
  if (roi >= 1.0) return { label: "⚠️ Moderate ROI", color: "#D69E2E" };
  return { label: "❄️ Low ROI", color: "#A0AEC0" };
}

// Returns trend icon comparing current vs previous ROI
export function getTrendIcon(current, previous = 0) {
  const delta = current - previous;
  if (delta > 0.05) return "📈";
  if (delta < -0.05) return "📉";
  return "➖";
}

// Returns days remaining until auto-fill (28-day countdown)
export function getAutofillCountdown(readyAt) {
  if (!readyAt) return null;
  const daysElapsed = Math.floor((Date.now() - new Date(readyAt)) / (1000 * 60 * 60 * 24));
  return 28 - daysElapsed;
}
